import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/block/hero/blue-bus.webp")